import moment from "moment";
import { Colour_Tournament } from "./utils";
const CLOCK_COLOUR_PATH =
  "IMAGE*__SKY_SPORTS/TEAM_ELEMENTS/UNIVERSAL/TEAM_COLOURS/";
export class Clock {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    triggerAnimation,
    getVizPage,
    updateVizPage,
    vizSharedMemory,
  }) {
    this.onAir = localStorage.getItem("netball-clock-on-air") === "true";
    this.time = 0;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.triggerAnimation = triggerAnimation;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.vizSharedMemory = vizSharedMemory;
    this.name = "CLOCK";
    this.scene = "Clock";
    this.data = [];
    this.page = 10000;
  }

  preview({ options }) {
    this.onAir = false;
  }
  async animate({ options }) {
    this.onAir = true;
    localStorage.setItem("netball-clock-on-air", "true");
    let xml = await this.getVizPage({ page: this.page }).catch((err) => {
      console.log(err);
    });
    if (xml) {
        if (options.centre) {
              this.centre = options.centre;
            }
      // xml = Colour_Tournament({ game: options.game, xml });

      xml.payload.field.find((item) => {
        return item.attr.name === "0000";
      }).value = "";

      xml.payload.field.find((item) => {
        return item.attr.name === "0008";
      }).value = options.period === 1 ? "1st" 
      : options.period === 2 ? "2nd"
      : options.period === 3 ? "ET"
      : options.period;

      xml.payload.field.find((item) => {
        return item.attr.name === "0010";
      }).value = 0;

      xml.payload.field.find((item) => {
        return item.attr.name === "0011";
      }).value = "";

      xml.payload.field.find((item) => {
        return item.attr.name === "0101";
      }).value = options?.game?.home_team?.name || "";

      xml.payload.field.find((item) => {
        return item.attr.name === "0102";
      }).value = options?.game?.away_team?.name || "";

      xml.payload.field.find((item) => {
        return item.attr.name === "0104";
      }).value = options?.game?.home_team?.code || "";

      xml.payload.field.find((item) => {
        return item.attr.name === "0105";
      }).value = options?.game?.away_team?.code || "";

         xml.payload.field.find((item) => {
                  return item.attr.name === "0030";
                }).value = this.centre === "none" ? "0" : "1";
                
       xml.payload.field.find((item) => {
                  return item.attr.name === "0031";
                }).value = this.centre === "home" ? "1" : "2";

      let kit = options.homeKit;

      xml.payload.field.find((item) => {
        return item.attr.name === "0901";
      }).value = (
        options?.game?.home_team?.name?.toUpperCase() +
        " " +
        kit?.toUpperCase()
      )?.replaceAll(" ", "_");

      try {
        let stripeColour =
          options?.game?.home_team?.variables?.[kit + "_kit_stripe_viz"];
        xml.payload.field.find((item) => {
          return item.attr.name === "0121.active"; // home team back colour
        }).value = stripeColour && stripeColour !== "" ? "1" : "0";
      } catch (err) {}

      kit = options.awayKit;

      xml.payload.field.find((item) => {
        return item.attr.name === "0902";
      }).value = (
        options?.game?.away_team?.name?.toUpperCase() +
        " " +
        kit?.toUpperCase()
      )?.replaceAll(" ", "_");

      try {
        let stripeColour =
          options?.game?.away_team?.variables?.[kit + "_kit_stripe_viz"];
        xml.payload.field.find((item) => {
          return item.attr.name === "0141.active"; // home team back colour
        }).value = stripeColour && stripeColour !== "" ? "1" : "0";
      } catch (err) {}

      await this.updateVizPage({ page: this.page, data: xml }).catch((err) => {
        console.log(err);
      });
    }

    this.sendAnimate({ page: this.page });
  }

  async update({ options }) {
    if (this.onAir) {
      let home_score = 0;
      let away_score = 0;

      home_score = parseInt(options?.game?.scores_by_quarter?.home?.goals ?? 0);
      away_score = parseInt(options?.game?.scores_by_quarter?.away?.goals ?? 0);

      switch (options?.action || options?.type) {
        default:
          if (
            this.super_shot_flash !== options.super_shot_flash ||
            this.super_shot !== options.super_shot ||
            this.home_score !== (home_score || 0) ||
            this.away_score !== (away_score || 0) ||
            this.period !== options.period ||
            (options.centre && this.centre !== options.centre) ||
            (options.centre_mode && this.centre_mode !== options.centre_mode)
          ) {
            if (options.centre) {
              this.centre = options.centre;
            }
             if (options.centre_mode) {
              this.centre_mode = options.centre_mode;
            }
            this.period = options.period;
            this.two_points =
              home_score - this.home_score === 2
                ? true
                : away_score - this.away_score === 2
                  ? true
                  : false;
            this.home_score = home_score;
            this.away_score = away_score;
            this.super_shot = options.super_shot;
            this.super_shot_flash = options.super_shot_flash;

            let xml = await this.getVizPage({ page: this.page }).catch(
              (err) => {
                console.log(err);
              },
            );
            if (xml) {
              xml.payload.field.find((item) => {
                return item.attr.name === "0000";
              }).value = this.super_shot && this.two_points ? "SUPER SHOT" : "";

              xml.payload.field.find((item) => {
                return item.attr.name === "0010";
              }).value = this.super_shot ? 1 : 0;

              xml.payload.field.find((item) => {
                return item.attr.name === "0011";
              }).value = this.super_shot_flash;

              xml.payload.field.find((item) => {
                return item.attr.name === "0002";
              }).value = home_score || 0;

              xml.payload.field.find((item) => {
                return item.attr.name === "0003";
              }).value = away_score || 0;

              xml.payload.field.find((item) => {
                return item.attr.name === "0008";
              }).value = this.period || "";

              if (options.centre_mode) {
                xml.payload.field.find((item) => {
                  return item.attr.name === "0030";
                }).value = this.centre_mode === "manual" ? "0" : "1";
                xml.payload.field.find((item) => {
                  return item.attr.name === "0031";
                }).value = this.centre_mode === "manual" ? "1" : "2";
              }

              if (options.centre) {
                xml.payload.field.find((item) => {
                  return item.attr.name === "0030";
                }).value = this.centre === "none" ? "0" : "1";
                xml.payload.field.find((item) => {
                  return item.attr.name === "0031";
                }).value = this.centre === "home" ? "1" : "2";
              }

              await this.updateVizPage({
                page: this.page,
                data: xml,
              }).catch((err) => {
                console.log(err);
              });
              this.sendAnimate({ page: this.page });
            }
          }
      }
    }
  }

  animateOff({ options }) {
    localStorage.setItem("netball-clock-on-air", "false");
    this.onAir = false;
    this.sendAnimateOff({ page: this.page });
  }
}
